<template>
    <div class="container">
        <br><br>
        <section class="section-padding">
            <div class="container">
                
            </div>
            
            <div class="container">
                <div class="text-center">
                    <h2 class="section-title text-uppercase">Realisasi Belanja OPD Tahun 2024</h2>
                    <p class="section-sub">
                        Update Terakhir : {{ convert_tgl(update) }}
                    </p>
                </div>

                
                 

                <div class="panel-group mt-50 mb-50" id="accordion">
                    <div class="row">
                        <div class="col-md-4 mb-15">
                            <div class="panel panel-default">
                                <div class="panel-heading " style="background-color: #d9edf7">
                                    <h4 class="panel-title text-center pb-10">
                                        <a style="font-size: 10pt !important;"  data-bs-toggle="collapse" href="#collapse1" role="button" aria-expanded="false" aria-controls="collapse1">
                                            <span v-if="totalPendapatan == '' || totalPendapatan == null">
                                                Pendapatan Daerah Rp. 0
                                            </span>
                                            <span v-else>
                                                Pendapatan Daerah Rp. {{toLocaleString(parseInt(totalPendapatan))}}
                                            </span>
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse1" class="collapse">
                                    <div class="panel-body">
                                        <table>
                                            <tr v-for="data in list_pendapatan" :key="data.id">
                                                <td class="fontkecil">{{data.uraian}}</td>
                                                <td class="fontkecil">Rp.</td>
                                                <td class="fontkecil"> {{toLocaleString(parseInt(data.jml))}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-15">
                            <div class="panel panel-default">
                                <div class="panel-heading" style="background-color: #effdda">
                                    <h4 class="panel-title text-center pb-10">
                                        <a style="font-size: 10pt !important;" data-bs-toggle="collapse" href="#collapse2" role="button" aria-expanded="false" aria-controls="collapse2">
                                            <span v-if="totalBelanja == '' || totalBelanja == null">
                                                Belanja Daerah Rp. 0
                                            </span>
                                            <span v-else>
                                                Belanja Daerah Rp. {{toLocaleString(parseInt(totalBelanja))}}
                                            </span>
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse2" class="collapse">
                                    <div class="panel-body">
                                        <table>
                                            <tr v-for="data in list_belanja" :key="data.id">
                                                <td class="fontkecil">{{data.uraian}}</td>
                                                <td class="fontkecil">Rp.</td>
                                                <td class="fontkecil"> {{toLocaleString(parseInt(data.jml))}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-15">
                            <div class="panel panel-default">
                                <div class="panel-heading" style="background-color: #fff8ca">
                                    <h4 class="panel-title text-center pb-10">
                                        <a style="font-size: 10pt !important;" data-bs-toggle="collapse" href="#collapse3" role="button" aria-expanded="false" aria-controls="collapse3">
                                            <span v-if="totalPembiayaan == '' || totalPembiayaan == null">
                                                Pembiayaan Daerah Rp. 0
                                            </span>
                                            <span v-else>
                                                Pembiayaan Daerah Rp. {{toLocaleString(parseInt(totalPembiayaan))}}
                                            </span>
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse3" class="collapse">
                                    <div class="panel-body">
                                         <table>
                                            <tr v-for="data in list_pembiayaan" :key="data.id">
                                                <td class="fontkecil">{{data.uraian}}</td>
                                                <td class="fontkecil">Rp.</td>
                                                <td class="fontkecil"> {{toLocaleString(parseInt(data.jml))}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div ref="pendapatanDaerah"   style="width:100%; height:400px;"></div>
                    </div>
                    <div class="col-md-4">
                        <div ref="belanjaDaerah"   style="width:100%; height:400px;"></div>
                    </div>
                    <div class="col-md-4">
                        <div ref="pembiayaanDaerahx" style="width:100%; height:400px;"></div>
                    </div>
                </div> <br><br>

                <div class="row mt-10">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <span class="progress-title" style="font-size: 22px;">Total Belanja</span>
                            </div>
                            <div class="col-md-6 text-right">
                                <span class="progress-title" style="font-size: 18px;">Rp. {{toLocaleString(parseInt(totalRealisasi))}} / Rp. {{toLocaleString(parseInt(totalPagu))}} ({{ parseFloat(totalPersen).toFixed(2) }}%)</span>
                            </div>
                        </div>

<div v-if="totalPersen < 25">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-danger" :style="{width:parseFloat(totalPersen).toFixed(2) + '%'}">{{parseFloat(totalPersen).toFixed(2)}}%</div>
    </div>
</div>
<div v-else-if="totalPersen > 25 && totalPersen < 50">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-danger" :style="{width:parseFloat(totalPersen).toFixed(2) + '%'}">{{parseFloat(totalPersen).toFixed(2)}}%</div>
    </div>
</div>
<div v-else-if="totalPersen > 50 && totalPersen < 75">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-danger" :style="{width:parseFloat(totalPersen).toFixed(2) + '%'}">{{parseFloat(totalPersen).toFixed(2)}}%</div>
    </div>
</div>
<div v-else-if="totalPersen > 75">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-success" :style="{width:parseFloat(totalPersen).toFixed(2) + '%'}">{{parseFloat(totalPersen).toFixed(2)}}%</div>
    </div>
</div>


                        <!-- <div class="progress" style="height: 25px;">
                            <div v-if="totalPersen < 25">
                                <div class="progress-bar progress-bar-danger" role="progressbar" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(totalPersen).toFixed(2) + '%'}">
                                    {{parseFloat(totalPersen).toFixed(2)}}%
                                </div>
                            </div>
                            <div v-else-if="totalPersen > 25 && totalPersen < 50">
                                <div class="progress-bar progress-bar-warning" role="progressbar" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(totalPersen).toFixed(2) + '%'}">
                                    {{parseFloat(totalPersen).toFixed(2)}}%
                                </div>
                            </div>
                            <div v-else-if="totalPersen > 50 && totalPersen < 75">
                                <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(totalPersen).toFixed(2) + '%'}">
                                    {{parseFloat(totalPersen).toFixed(2)}}%
                                </div>
                            </div>
                            <div v-else-if="totalPersen > 75">
                                <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(totalPersen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(totalPersen).toFixed(2) + '%'}">
                                    {{parseFloat(totalPersen).toFixed(2)}}%
                                </div>
                            </div> 
                        </div> -->


                    </div>
                </div> <br><br>

                <div>
                    <span class="progress-title text-left" style="font-size: 22px;">Realisasi Masing-masing OPD</span>
                </div>
                
                <div v-for="data in list_opd" :key="data.id">
                    <div class="row">
                        <div class="col-md-6 text-left">
                            <span class="progress-title">{{data.opd}}</span>
                        </div>
                        <div class="col-md-6 text-right">
                            <span class="progress-title">Rp. {{toLocaleString(parseInt(data.realisasi))}} / Rp. {{toLocaleString(parseInt(data.pagu))}} ({{ parseFloat(data.persen).toFixed(2) }}%)</span>
                        </div>
                    </div>

<div v-if="data.persen < 25">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-danger" :style="{width:parseFloat(data.persen).toFixed(2) + '%'}">{{parseFloat(data.persen).toFixed(2)}}%</div>
    </div>
</div>
<div v-else-if="data.persen > 25 && data.persen < 50">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-warning" :style="{width:parseFloat(data.persen).toFixed(2) + '%'}">{{parseFloat(data.persen).toFixed(2)}}%</div>
    </div>
</div>
<div v-else-if="data.persen > 50 && data.persen < 75">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar " :style="{width:parseFloat(data.persen).toFixed(2) + '%'}">{{parseFloat(data.persen).toFixed(2)}}%</div>
    </div>
</div>
<div v-else-if="data.persen > 75">
    <div style="height: 25px;" class="progress " role="progressbar" aria-label="Success example" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar text-bg-success" :style="{width:parseFloat(data.persen).toFixed(2) + '%'}">{{parseFloat(data.persen).toFixed(2)}}%</div>
    </div>
</div>

                    
                    <!-- <div class="progress" style="height: 15px;">
                        <div v-if="data.persen < 25">
                            <div class="progress-bar progress-bar-danger" role="progressbar" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(data.persen).toFixed(2) + '%'}">
                                {{parseFloat(data.persen).toFixed(2)}}%
                            </div>
                        </div>
                        <div v-else-if="data.persen > 25 && data.persen < 50">
                            <div class="progress-bar progress-bar-warning" role="progressbar" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(data.persen).toFixed(2) + '%'}">
                                {{parseFloat(data.persen).toFixed(2)}}%
                            </div>
                        </div>
                        <div v-else-if="data.persen > 50 && data.persen < 75">
                            <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(data.persen).toFixed(2) + '%'}">
                                {{parseFloat(data.persen).toFixed(2)}}%
                            </div>
                        </div>
                        <div v-else-if="data.persen > 75">
                            <div class="progress-bar progress-bar-success" role="progressbar" :aria-valuenow="Math.round(data.persen)" aria-valuemin="0" aria-valuemax="100" :style="{width: parseFloat(data.persen).toFixed(2) + '%'}">
                                {{parseFloat(data.persen).toFixed(2)}}%
                            </div>
                        </div> 
                    </div> -->
                    
                </div>
            </div>
        </section>
    </div>
</template>

<script>

// const this.$store.state.URL.realisasi_anggaran = URL_APP + "api/v1/publish_bpkad_realisasi_anggaran/";
import { ref, nextTick } from 'vue';
import Highcharts from 'highcharts';

Highcharts.setOptions({
  lang: {
    // Atur locale dengan benar (wajib), misal Indonesia
    locale: 'id-ID',
    decimalPoint: ',',
    thousandsSep: '.'
  }
});


export default {

    data() {
        return {
            data_load: false,
            totalBelanja: '',
            belanjaPegawai: '',
            belanjaModal: '',
            belanjaBarangJasa: '',
            belanjaTidakTerduga: '',
            totalPendapatan: '',
            totalPembiayaan: '',
            realisasiAnggaran: '',
            selisih: '',
            update : '',
            list_data: [],
            list_opd : [],
            list : [
                {id: 1, nama: 'Task A', nilai: 75},
                {id: 2, nama: 'Task B', nilai: 50},
                {id: 3, nama: 'Task C', nilai: 90},
            ],

            paguOPD: '',
            realisasiOPD: '',
            silpa: '',
            totalx: '',
            totalPagu: '',
            totalRealisasi: '',
            totalPersen: '',

            list_pendapatan : [],
            list_belanja : [],
            list_pembiayaan : [],

            tahun : 2024,

        }
    },
    methods: {

        getView: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    // tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    // console.log(res_data);
                });
        },

        getTotalBelanja: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "totalBelanja", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.totalBelanja = res_data.totalBelanja;
                    // console.log(res_data);
                });
        },

        getTotalPendapatan: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "totalPendapatan", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.totalPendapatan = res_data.totalPendapatan;
                    // console.log(res_data);
                });
        },

        getTotalPembiayaan: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "totalPembiayaan", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.totalPembiayaan = res_data.totalPembiayaan;
                    // console.log(res_data);
                });
        },

        getBelanjaPegawai: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "belanjaPegawai", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.belanjaPegawai = res_data.belanjaPegawai;
                    // console.log(res_data);
                });
        },

        getBelanjaModal: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "belanjaModal", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.belanjaModal = res_data.belanjaModal;
                    // console.log(res_data);
                });
        },

        getBelanjaBarangJasa: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "belanjaBarangJasa", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.belanjaBarangJasa = res_data.belanjaBarangJasa;
                    // console.log(res_data);
                });
        },

        getBelanjaTidakTerduga: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "belanjaTidakTerduga", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.belanjaTidakTerduga = res_data.belanjaTidakTerduga;
                    // console.log(res_data);
                });
        },

        getRealisasiAnggaran: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "realisasiAnggaran", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.realisasiAnggaran = res_data.realisasiAnggaran;
                    // console.log(res_data);
                });
        },

        getSilpa: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "silpa", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.silpa = res_data.silpa;


                    // console.log(res_data);
                });
        },

        getSelisih: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "selisih", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.selisih = res_data.selisih;
                    // console.log(res_data);
                });
        },

        getOPD: function() {
            fetch(this.$store.state.URL.realisasi_anggaran + "viewOPD", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_opd = res_data;
                    // console.log(res_data);
            });
        },

        getPendapatan: function() {
            fetch(this.$store.state.URL.realisasi_anggaran + "pendapatan", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_pendapatan = res_data;
                    console.log(res_data);
            });
        },

        getBelanja: function() {
            fetch(this.$store.state.URL.realisasi_anggaran + "belanja", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_belanja = res_data;
                    // console.log(res_data);
            });
        },

        getPembiayaan: function() {
            fetch(this.$store.state.URL.realisasi_anggaran + "pembiayaan", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_pembiayaan = res_data;
                    // console.log(res_data);
            });
        },

        async pendapatanDaerah (){
            fetch(this.$store.state.URL.realisasi_anggaran + "pendapatanDaerah", {
				method: "POST",
				headers: {
					"content-type": "application/json",
					authorization: "kikensbatara " + localStorage.token
				},
                body: JSON.stringify({
                    tahun: this.tahun
                })
			}).then(res => res.json())
				.then( async res_data => {
				this.pendapatan = res_data.data;

				var pendapatan = [];
				var hasil = this.pendapatan;
				for(var i in hasil) {
					pendapatan.push([
						hasil[i].name,
						hasil[i].y
					])
				}
				// console.log(res_data);
                await nextTick()
				this.piePendapatan(pendapatan);
	 
                //  nextTick(() => {
                //     this.piePendapatan(pendapatan);
                // });

			});
        },

        piePendapatan(pendapatan){
            
            Highcharts.chart(this.$refs.pendapatanDaerah, {
                chart: {
					borderColor: '#transparent',
					borderWidth: 2,
				},
                title: {
					text: 'Pendapatan Daerah'
				},
				xAxis: {
					type: 'category'
				},
                series: [{
                    type: 'pie',
                    data: pendapatan,
                }]
            });
        },

        async belanjaDaerah(){
            fetch(this.$store.state.URL.realisasi_anggaran + "belanjaDaerahxxx", {
				method: "POST",
				headers: {
					"content-type": "application/json",
					authorization: "kikensbatara " + localStorage.token
				},
                body: JSON.stringify({
                    tahun: this.tahun
                })
			}).then(res => res.json())
				.then(async res_data => {
				this.belanja = res_data.data;

				var belanja = [];
				var hasil = this.belanja;
				for(var i in hasil) {
					belanja.push([
						hasil[i].name,
						hasil[i].y
					])
				}
				// console.log(res_data);
                await nextTick()
				this.pieBelanja(belanja);
                // await nextTick(() => {
                //     this.pieBelanja(belanja);
                // });
			});
        },

        pieBelanja(belanja){
            Highcharts.chart(this.$refs.belanjaDaerah, {
                chart: {
					borderColor: '#transparent',
					borderWidth: 2,
				},
                title: {
					text: 'Belanja Daerah'
				},
				xAxis: {
					type: 'category'
				},
                series: [{
                    type: 'pie',
                    data: belanja,
                }]
            });
        },

        async pembiayaanDaerah(){ 
            fetch(this.$store.state.URL.realisasi_anggaran + "pembiayaanDaerah", {
				method: "POST",
				headers: {
					"content-type": "application/json",
					authorization: "kikensbatara " + localStorage.token
				},
                body: JSON.stringify({
                    tahun: this.tahun
                })
			}).then(res => res.json())
				.then(async res_data => {
				this.pembiayaan = res_data.data;

				var pembiayaan = [];
				var hasil = this.pembiayaan;
				for(var i in hasil) {
					pembiayaan.push([
						hasil[i].name,
						hasil[i].y
					])
				}
                await nextTick()

                // setInterval(() => {
                // }, 3000);

                this.piePembiayaan(pembiayaan)
                
                
			});
        },

        piePembiayaan(pembiayaan){
            if (!this.$refs.pembiayaanDaerahx) {
                console.warn("Elemen pembiayaanDaerah belum siap di DOM!");
                return;
            }

            console.log(this.$refs.pembiayaanDaerahx);
            
            Highcharts.chart(this.$refs.pembiayaanDaerahx, {
                chart: {
					borderColor: '#transparent',
					borderWidth: 2,
				},
                title: {
					text: 'Pembiayaan Daerah'
				},
				xAxis: {
					type: 'category'
				},
                series: [{
                    type: 'pie',
                    data: pembiayaan,
                }]
            });

            // Highcharts.chart(this.$refs.pembiayaanDaerah, {
            //     chart: {
			// 		borderColor: '#transparent',
			// 		borderWidth: 2,
			// 	},
            //     title: {
			// 		text: 'Pembiayaan Daerah'
			// 	},
			// 	xAxis: {
			// 		type: 'category'
			// 	},
            //     series: [{
            //         type: 'pie',
            //         data: pembiayaan,
            //     }]
            // });
        },

        selectData: function (data) {
            this.form = {
                id: data.id,
                // kategori : data.kategori,
                judul: data.judul,
                file: data.file,
            };
        },

        mdl_exit: function () {
            this.judul = "";
            this.uraian = "";
            this.file = "";
            this.file_old = "";
        },

        getUpdate : function(){
            fetch(this.$store.state.URL.realisasi_anggaran + "viewUpdate", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.update = res_data.createAt;
                    // console.log(this.update);
                });
        },

        //   ====================== MODAL ======================

        buka_modal: function (modalku) {
            var modal = document.getElementById(modalku);
            modal.style.display = "block";
        },

        tutup_modal: function (modalku) {
            var modal = document.getElementById(modalku);
            modal.style.display = "none";
        },


        //   ====================== MODAL ======================
        // ================== PAGINASI ====================
        alertku: function (type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
        },

        btn_prev: function () {
            if (this.page_first > 1) {
                this.page_first--
            } else {
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next: function () {

            if (this.page_first >= this.page_last) {
                this.page_first == this.page_last
            } else {
                this.page_first++;
            }
            this.getView();
        },

        cari_data: function () {

            this.page_first = 1;
            this.getView();
        },


        toLocaleString: function(data){
            let text = data.toLocaleString("id-ID");
            return text
        },

        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            // const options = { weekday: 'long' };
            // const hariIndonesia = today.toLocaleDateString('id-ID', options);

            // var getBulan = date.getMonth() + 1; var bulan = '';
            // if (getBulan == '1') {bulan = 'Jan'} 
            // else if(getBulan == '2') {bulan = 'Feb'}
            // else if(getBulan == '3') {bulan = 'Mar'}
            // else if(getBulan == '4') {bulan = 'Apr'}
            // else if(getBulan == '5') {bulan = 'Mei'}
            // else if(getBulan == '6') {bulan = 'Jun'}
            // else if(getBulan == '7') {bulan = 'Jul'}
            // else if(getBulan == '8') {bulan = 'Agt'}
            // else if(getBulan == '9') {bulan = 'Sep'}
            // else if(getBulan == '10') {bulan = 'Okt'}
            // else if(getBulan == '11') {bulan = 'Nov'}
            // else if(getBulan == '12') {bulan = 'Des'}



            // return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
            
            
            return date



            // Membuat tanggal saat ini
            // const today = new Date();

            // // Mendapatkan nama hari dalam bahasa Indonesia
            // const options = { weekday: 'long' }; // 'long' akan menampilkan nama hari lengkap
            // const hariIndonesia = today.toLocaleDateString('id-ID', options);

            // console.log(hariIndonesia); // Output: "Senin", "Selasa", dll. tergantung hari saat ini

        },
        // ================== PAGINASI ====================

        getTotal: function () {
            fetch(this.$store.state.URL.realisasi_anggaran + "total", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    tahun: this.tahun
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.totalRealisasi = res_data.totalRealisasi;
                    this.totalPagu = res_data.totalPagu;
                    this.totalPersen = res_data.totalPersen;
                    // console.log(res_data);

                    // console.log(this.totalRealisasi);
                    // console.log(this.totalPagu);
                    
                });
        },




        KehadiranPie : function(){
            Highcharts.chart('KehadiranPie', {
                chart: {
                    type: 'column',
                    inverted: true,
                    polar: true,
                    marginTop: 25
                },
                title: {
                    text: 'Stacked inverted polar bars'
                },
                xAxis: {
                    tickInterval: 1,
                    labels: {
                    y: 15
                    }
                },
                yAxis: {
                    min: 0,
                    max: 45
                },
                plotOptions: {
                    column: {
                    stacking: 'normal',
                    borderWidth: 0,
                    pointPadding: 0,
                    groupPadding: 0.15,
                    pointPlacement: 'between',
                    dataLabels: {
                        enabled: true,
                        allowOverlap: true,
                        textPath: {
                        enabled: true,
                        attributes: {
                            textAnchor: 'start',
                            startOffset: 5,
                            dy: 11.5
                        }
                        }
                    }
                    }
                },
                series: [{
                    data: [7, 6, 9, 14, 18, 21, 25, 26, 23, 18]
                }, {
                    data: [3, 4, 5, 8, 11, 15, 17, 16, 14, 10]
                }]
            });
        },

        
    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        this.getUpdate();
        this.getTotalPendapatan();
        this.getTotalBelanja();
        this.getTotalPembiayaan();

        this.getPendapatan();
        this.getBelanja();
        this.getPembiayaan();
        
        this.pendapatanDaerah();
        this.belanjaDaerah();
        this.pembiayaanDaerah();
        

        this.getTotal();
        this.getOPD();

        // this.getView();
        // this.getBelanjaPegawai();
        // this.getBelanjaModal();
        // this.getBelanjaBarangJasa();
        // this.getBelanjaTidakTerduga();
        // this.getRealisasiAnggaran();
        // this.getSelisih();
        // this.getSilpa();




        // this.KehadiranPie();
    }
};
</script>


<style scoped>

.fontkecil{
    font-size: 10pt !important;
}

</style>